import { Box, Typography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SwitchModeTipCard = function SwitchModeTipCard(props) {
  var info = props.info;

  if (!(info !== null && info !== void 0 && info.content)) {
    return null;
  }

  return /*#__PURE__*/_jsxs(Box, {
    className: "flex flex-col items-center space-y-2 px-5 py-1",
    children: [/*#__PURE__*/_jsx(Typography, {
      className: "rounded-full bg-white/75 px-3 py-1 text-[12px] leading-4 text-[#6B7280] shadow-sm backdrop-blur-sm",
      children: info.content
    }), !!info.description && /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col items-center rounded-full bg-white/75 px-3 py-1",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "text-[11px] leading-4 text-[#6B7280] shadow-sm backdrop-blur-sm",
        children: info.description
      }), !!info.email && /*#__PURE__*/_jsx("a", {
        href: "mailto:".concat(info.email),
        className: "text-brand-secondary text-[11px]",
        children: info.email
      })]
    })]
  });
};

export default SwitchModeTipCard;